module.exports = __webpack_public_path__ + "static/media/potatoe-farm.c7ca0c50.PNG";